/* design—light · megamenu tile price row (2026-08-10)

   The grid tiles moved their price off the photo and into the title/brand row
   (assets/dl-tile-meta.css). Megamenu tiles carry the same chip, but their markup is
   server-rendered inside sections/dl-header-b.liquid as

       a.navx-pcard > span.navx-th > span.navx-pr        <- the chip
                    > span.navx-meta > span.tt + span.vd

   and .navx-th is position:relative + overflow:hidden, so the chip cannot be
   re-parented in CSS. This moves the node once, tags it .navx-prm, and lets
   dl-tile-meta.css lay the row out.

   A tile with no .navx-meta (the room cover tile in Místnosti) is skipped and keeps
   its chip — the price would otherwise have nowhere to go. Runs twice: once when the
   DOM is ready and once ~1.2s later, so panels rendered late are picked up too. The
   second pass is a no-op for anything already moved (the selector requires the chip
   to still be inside .navx-th). */
(function(){
  function move(){
    var chips = document.querySelectorAll('.navx-pcard > .navx-th > .navx-pr');
    for (var i = 0; i < chips.length; i++) {
      var pr = chips[i];
      var card = pr.parentNode.parentNode;
      var meta = card.querySelector('.navx-meta');
      if (!meta) continue;
      pr.classList.add('navx-prm');
      meta.appendChild(pr);
    }
  }
  /* 2026-10-26 (perf): exposed for the lazy rails in dl-navx.js, which insert megamenu tiles
     long after this file's two passes have run. Idempotent, like the second pass. */
  window.dlNavxPriceMove = move;
  function run(){ move(); setTimeout(move, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
